export default function Logo({ className = "", showText = true, size = 28 }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="2" y="2" width="36" height="36" rx="9" fill="#0A0A0A" />
        <path d="M11 13H29" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M20 13V29" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="29" cy="29" r="3.5" fill="#2563EB" />
      </svg>
      {showText && (
        <span className="font-display font-bold text-[1.15rem] tracking-tight text-brand-ink leading-none">
          Telstra<span className="text-brand-blue">Nics</span>
        </span>
      )}
    </div>
  );
}
